/* eslint-disable react-hooks/exhaustive-deps, no-unused-expressions */
import { useMemo } from 'react';
import { StayDates } from '../DatesForm';
import { haveDatesChanged } from 'lib/utils';
import { doDatesContain } from './doDatesContain';

interface Options {
  isValid: boolean;
  loading: boolean;
  dates: StayDates;
  originalDates: StayDates;
  unavailableDates?: StayDates;
}

export const useSubmitEnabled = ({ isValid, loading, dates, originalDates, unavailableDates }: Options) => {
  return useMemo(() => {
    if (loading) return false;
    if (!isValid) return false;
    if (!haveDatesChanged(dates, originalDates)) return false;
    if (doDatesContain(dates, unavailableDates)) return false;
    return true;
  }, [isValid, loading, dates, Object.values(originalDates), Object.values(unavailableDates || {})]);
};
